<template>
  <div style="text-align:left;" class="sections-container">
    <!-- Iteramos sobre el array de secciones en cada objeto del array -->
    <div v-for="(data, index) in sections" :key="index" class="section">
      <h2 class="section-title">{{ data.titulo }}</h2>
      <div v-for="section in data.secciones" :key="section.id_seccion" class="subsection">
        <h3 class="subsection-title">{{ section.titulo_seccion }}</h3>
        <div v-for="contenido in section.contenido_seccion" :key="contenido.id_subtitulo" class="content-block">
          <h4 class="content-title"> {{ contenido.subtitulo_seccion }}</h4>
          <div v-for="item in contenido.contenido" :key="item.id_subsubtitulo" class="item-block">
            <h5 class="item-title">{{ item.subsubtitulo_seccion }}</h5>
              <ul class="file-list">
                <li v-for="archivo in item.archivos_seccion" :key="archivo.id_archivo" class="file-item">
                  <!-- Vinculamos los archivos utilizando el prop 'urlServe' -->
                  <a v-if="archivo.url_pdf" :href="`${urlServe}/${archivo.url_pdf}`" target="_blank" class="file-link pdf-link">
                    {{ archivo.titulo }}
                  </a>
                  <a v-if="archivo.url_word" :href="`${urlServe}/${archivo.url_word}`" target="_blank" class="file-link word-link">
                    {{ archivo.titulo }}
                  </a>
                  <a v-if="archivo.url_excel" :href="`${urlServe}/${archivo.url_excel}`" target="_blank" class="file-link excel-link">
                    {{ archivo.titulo }}
                  </a>
                  <a v-if="archivo.url_comprimido" :href="`${urlServe}/${archivo.url_comprimido}`" target="_blank" class="file-link">
                    {{ archivo.titulo }}
                  </a>
                </li>
              </ul>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sections: {
      type: Array, // Se espera que sea un array de objetos
      required: true
    },
    urlServe: {
      type: String, // URL base para acceder a los archivos
      required: true
    }
  }
};
</script>

<style scoped>
/* Contenedor general de las secciones */
.sections-container {
  padding: 20px;
}

/* Estilos para los títulos de cada nivel */
.section-title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
  border-bottom: 2px solid #ddd;
  padding-bottom: 5px;
}

.subsection-title {
  font-size: 15px;
  font-weight: 700;
  color: #801a42;
  margin-top: 15px;
  margin-bottom: 10px;
}

.content-title {
  font-size: 14px;
  padding-left: 1rem;
  font-weight: 500;
  color: #2e2e2e;
  margin-top: 10px;
  padding-bottom:3px;
  /* border-bottom: 1px dotted rgb(189, 182, 182); */
}

.item-title {
  font-size: 16px;
  font-weight: 600;
  color: #888;
  margin-top: 5px;
}

/* Estilos para las listas de archivos */
.file-list {
  list-style: none; 
  padding-left: 2rem;
  margin-top: 5px;
  padding-left: 1rem;
}

.file-item {
  margin: 10px 0;
  transition: ease all .2s;
  border-bottom: 1px dotted rgb(189, 182, 182);
}
.file-item:hover{
  transform: scale(1.01)!important;
}

/* Enlaces de archivos con iconos de color según el tipo */
.file-link {
  margin-left: 10px;
  text-decoration: none;
  /* font-weight: 500; */
  font-size: 14px;
  color:#202020;
  padding: 3px 5px;
  border-radius: 5px;
  transition: ease all .2s;
}
.file-item a:hover{
  color: #801a42;
}
</style>
